(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantra-announcement"] && !Shopify.designMode) return;
  try {
    
  class VantraAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.van__item'));
      if (this.items.length < 2) return;
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.timer = setInterval(() => this.tick(), parseInt(this.dataset.interval, 10) || 5000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const rotating = getComputedStyle(this.items[0]).position === 'absolute';
      if (!rotating || this.paused || this.reduced.matches || document.hidden) return;
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }
  }
  if (!customElements.get('vantra-announcement')) customElements.define('vantra-announcement', VantraAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantra-baseline"] && !Shopify.designMode) return;
  try {
    
  class VantraBaseline extends HTMLElement {
    connectedCallback() {
      this.max = parseInt(this.dataset.max, 10) || 25;
      this.count = parseInt(this.dataset.count, 10) || 5;
      this.answers = new Map();

      this.result = this.querySelector('[data-result]');
      this.scoreEl = this.querySelector('[data-score]');
      this.bandEl = this.querySelector('[data-band]');
      this.answeredEl = this.querySelector('[data-answered]');
      this.progressEl = this.querySelector('[data-progress]');

      this.bands = [
        { upTo: 0.24, text: this.dataset.band1 || 'This is barely happening to you yet.' },
        { upTo: 0.48, text: this.dataset.band2 || 'It is happening, and it is early.' },
        { upTo: 0.76, text: this.dataset.band3 || 'That is a pattern, not a bad week.' },
        { upTo: 1.01, text: this.dataset.band4 || 'That is most days, and you have been carrying it quietly.' },
      ];

      this.querySelectorAll('.vbl__q').forEach((q, qi) => {
        q.addEventListener('pointerdown', () => {
          document.dispatchEvent(new CustomEvent('vantra:baseline-active'));
        }, { once: true });
        q.querySelectorAll('.vbl__opt').forEach((opt) => {
          opt.addEventListener('click', () => this.pick(qi, q, opt));
          opt.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.pick(qi, q, opt); }
          });
        });
      });
    }

    pick(qi, q, opt) {
      q.querySelectorAll('.vbl__opt').forEach((o) => o.setAttribute('aria-checked', String(o === opt)));
      this.answers.set(qi, parseInt(opt.dataset.value, 10) || 0);
      this.render();
    }

    render() {
      const answered = this.answers.size;
      if (this.answeredEl) this.answeredEl.textContent = String(answered);
      if (answered < this.count) return;

      let total = 0;
      this.answers.forEach((v) => { total += v; });
      const ratio = this.max ? total / this.max : 0;
      const band = this.bands.find((b) => ratio <= b.upTo) || this.bands[this.bands.length - 1];

      if (this.scoreEl) this.scoreEl.textContent = String(total);
      if (this.bandEl) this.bandEl.textContent = band.text;
      if (this.progressEl) this.progressEl.hidden = true;
      if (this.result && this.result.hidden) {
        this.result.hidden = false;
        this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        // The moment she has a number is the moment saving it is worth something,
        // so anything that wants to ask for an email should ask now, not on a timer.
        document.dispatchEvent(new CustomEvent('vantra:baseline-complete', {
          detail: { score: total, max: this.max },
        }));
      }
    }
  }

  if (!customElements.get('vantra-baseline')) {
    customElements.define('vantra-baseline', VantraBaseline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantra-capture"] && !Shopify.designMode) return;
  try {
    
  class VantraCapture extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.key;
      if (this.seen()) return;

      this.panel = this.querySelector('.vcp__panel');
      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.dismiss()));
      this.onKey = (e) => { if (e.key === 'Escape') this.dismiss(); };

      // A submitted form reloads the page, so show the result rather than the offer again.
      if (this.querySelector('.vcp__msg')) { this.open(); return; }

      this.delay = (parseInt(this.dataset.delay, 10) || 45) * 1000;
      this.minScroll = parseInt(this.dataset.minscroll, 10) || 0;
      this.arm();

      // Interrupting somebody mid assessment wastes the best moment on the page.
      this.onActive = () => { clearTimeout(this.timer); this.paused = true; };
      document.addEventListener('vantra:baseline-active', this.onActive);

      // Finishing it is the moment saving the number is worth an email address.
      this.onDone = () => { this.paused = false; setTimeout(() => this.open(), 900); };
      document.addEventListener('vantra:baseline-complete', this.onDone);

      if (this.hasAttribute('data-exit')) {
        // mouseout fires whenever the cursor leaves any element at all, so a pointer
        // resting near the top of the window sets it off on every scroll. mouseleave
        // on the root element only fires when the pointer really leaves the document.
        this.armedAt = Date.now();
        this.onLeave = (e) => {
          if (this.paused || this.isOpen) return;
          if (Date.now() - this.armedAt < 5000) return;
          if (e.clientY > 0) return;
          this.open();
        };
        document.documentElement.addEventListener('mouseleave', this.onLeave);
      }
    }

    arm() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.tryOpen(), this.delay);
    }

    // Horizon scrolls inside .page-wrapper rather than the document, so read depth
    // off whichever element is actually doing the scrolling.
    scroller() {
      const wrap = document.querySelector('.page-wrapper');
      if (wrap && wrap.scrollHeight > wrap.clientHeight + 4) return wrap;
      return document.scrollingElement || document.documentElement;
    }

    depth() {
      const s = this.scroller();
      const max = s.scrollHeight - s.clientHeight;
      if (max <= 0) return 100;
      return (s.scrollTop / max) * 100;
    }

    // The timer proves she has had time. The scroll gate proves she has actually
    // read something. On a long article both have to be true before interrupting.
    tryOpen() {
      if (this.paused || this.isOpen) return;
      if (this.depth() >= this.minScroll) { this.open(); return; }
      if (this.onScroll) return;
      this.scrollEl = this.scroller();
      this.onScroll = () => {
        if (this.paused || this.isOpen) return;
        if (this.depth() >= this.minScroll) this.open();
      };
      this.scrollEl.addEventListener('scroll', this.onScroll, { passive: true });
    }

    dropScroll() {
      if (this.onScroll && this.scrollEl) this.scrollEl.removeEventListener('scroll', this.onScroll);
      this.onScroll = null;
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.dropScroll();
      document.removeEventListener('keydown', this.onKey);
      if (this.onLeave) document.documentElement.removeEventListener('mouseleave', this.onLeave);
      if (this.onActive) document.removeEventListener('vantra:baseline-active', this.onActive);
      if (this.onDone) document.removeEventListener('vantra:baseline-complete', this.onDone);
    }

    seen() {
      try { return localStorage.getItem(this.key) === '1'; } catch (e) { return false; }
    }

    remember() {
      try { localStorage.setItem(this.key, '1'); } catch (e) { /* private mode */ }
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      clearTimeout(this.timer);
      this.dropScroll();
      if (this.onLeave) document.documentElement.removeEventListener('mouseleave', this.onLeave);
      this.hidden = false;
      document.addEventListener('keydown', this.onKey);
      const input = this.querySelector('.vcp__input');
      if (input) input.focus({ preventScroll: true });
      this.remember();
    }

    dismiss() {
      this.dropScroll();
      this.hidden = true;
      this.isOpen = false;
      document.removeEventListener('keydown', this.onKey);
      this.remember();
    }
  }

  if (!customElements.get('vantra-capture')) {
    customElements.define('vantra-capture', VantraCapture);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantra-closer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-vcl2-add]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const qty = link.dataset.qty;
    const radio = document.querySelector(`vantra-offer-box .vob__radio[value="${qty}"]`);
    const form = document.querySelector('product-form-component form[action*="/cart/add"]');
    // No offer box or theme form on this page: let the link add to the cart natively.
    if (!radio || !form) return;
    event.preventDefault();
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    link.classList.add('is-adding');
    requestAnimationFrame(() => {
      form.requestSubmit();
      setTimeout(() => link.classList.remove('is-adding'), 1200);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantra-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vrv-more]');
    if (!button) return;
    const wrap = button.closest('.vrv__morewrap');
    const list = wrap && wrap.previousElementSibling;
    if (!list) return;
    const step = parseInt(list.dataset.step, 10) || 3;
    const label = button.querySelector('[data-vrv-more-label]');
    const items = Array.from(list.querySelectorAll('.vrv__item'));

    // Everything is open: collapse back to the first three and bring the section
    // back into view, so the reader is not left stranded further down the page.
    if (button.getAttribute('aria-expanded') === 'true') {
      items.forEach((item) => item.classList.remove('is-shown'));
      button.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = 'Show more reviews';
      const section = list.closest('section') || list;
      const top = section.getBoundingClientRect().top;
      if (top < 0) section.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      return;
    }

    const hidden = items.filter((item, i) => i >= 3 && !item.classList.contains('is-shown'));
    hidden.slice(0, step).forEach((item) => item.classList.add('is-shown'));
    if (hidden.length <= step) {
      button.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = 'Show less';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantra-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  class VantraStickyBar extends HTMLElement {
    connectedCallback() {
      this.box = document.querySelector('vantra-offer-box');
      this.qty = this.querySelector('[data-qty]');
      this.price = this.querySelector('[data-price]');
      this.was = this.querySelector('[data-was]');
      this.btnPrice = this.querySelector('[data-btnprice]');
      this.switchEl = this.querySelector('[data-switch]');

      // No offer box on the page, an advertorial for instance. Fall back to a scroll
      // depth trigger so the bar still appears once she is into the argument.
      if (!this.box) { this.standalone(); return; }
      this.hidden = false;

      this.buildSwitch();
      this.sync();
      this.box.addEventListener('change', () => this.sync());

      // Add to cart goes through the theme's own product form, so the fly to cart,
      // the count bubble and the cart drawer all behave exactly as they do for the
      // main button. The offer box already keeps that form's quantity in step with
      // the tier picked here. Without a theme form the native post still runs.
      this.form = this.querySelector('.vsb__form');
      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          const main = this.mainForm();
          if (!main) return;
          event.preventDefault();
          main.requestSubmit();
        });
      }

      // Show only once the offer box has left through the top of the viewport.
      this.observer = new IntersectionObserver(
        ([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          this.classList.toggle('is-shown', scrolledPast);
        },
        { threshold: 0 }
      );
      this.observer.observe(this.box);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onScroll && this.scrollEl) this.scrollEl.removeEventListener('scroll', this.onScroll);
    }

    // Horizon scrolls inside .page-wrapper rather than the document.
    scroller() {
      const wrap = document.querySelector('.page-wrapper');
      if (wrap && wrap.scrollHeight > wrap.clientHeight + 4) return wrap;
      return document.scrollingElement || document.documentElement;
    }

    depth() {
      const s = this.scroller();
      const max = s.scrollHeight - s.clientHeight;
      if (max <= 0) return 0;
      return (s.scrollTop / max) * 100;
    }

    standalone() {
      const at = parseInt(this.dataset.depth, 10);
      if (!at) return;
      this.hidden = false;
      this.scrollEl = this.scroller();
      this.onScroll = () => this.classList.toggle('is-shown', this.depth() >= at);
      this.scrollEl.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    mainForm() {
      const forms = Array.from(document.querySelectorAll('product-form-component form[action*="/cart/add"]'));
      return forms.find((form) => !this.contains(form)) || null;
    }

    radios() {
      return Array.from(this.box.querySelectorAll('.vob__radio'));
    }

    buildSwitch() {
      if (!this.switchEl) return;
      this.switchEl.textContent = '';
      this.radios().forEach((radio) => {
        const card = radio.closest('.vob__card');
        const name = card && card.querySelector('.vob__name');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vsb__seg';
        btn.dataset.qty = radio.value;

        const label = document.createElement('span');
        label.textContent = name ? name.textContent.trim() : `${radio.value}`;
        btn.appendChild(label);

        // Every tier gets a second line, so the three always share a baseline. The
        // days carry the argument the page makes: one bottle is thirty days, and that
        // is not long enough to judge.
        const sub = document.createElement('span');
        sub.className = 'vsb__segsub';
        const days = parseInt(radio.value, 10) * 30;
        if (days) sub.append(`${days} days`);
        if (radio.dataset.pct && radio.dataset.pct !== '0') {
          if (days) sub.append(' · ');
          const save = document.createElement('span');
          save.className = 'vsb__segsave';
          save.textContent = `${radio.dataset.pct}% off`;
          sub.appendChild(save);
        }
        if (sub.childNodes.length) btn.appendChild(sub);

        btn.addEventListener('click', () => {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.switchEl.appendChild(btn);
      });
    }

    sync() {
      const radio = this.box.querySelector('.vob__radio:checked');
      if (!radio) return;
      const d = radio.dataset;
      const discounted = Boolean(d.pct) && d.pct !== '0';

      if (this.qty) this.qty.value = radio.value;
      if (this.price) this.price.textContent = d.total || '';
      if (this.btnPrice) this.btnPrice.textContent = d.total || '';
      if (this.was) {
        this.was.hidden = !discounted;
        this.was.textContent = discounted ? d.was : '';
      }
      if (this.switchEl) {
        this.switchEl.querySelectorAll('.vsb__seg').forEach((b) => {
          b.setAttribute('aria-pressed', String(b.dataset.qty === radio.value));
        });
      }
    }
  }

  if (!customElements.get('vantra-sticky-bar')) {
    customElements.define('vantra-sticky-bar', VantraStickyBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantra-timeline"] && !Shopify.designMode) return;
  try {
    
  class VantraTimeline extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('.vtl__tile'));
      this.querySelectorAll('.vtl__supply').forEach((row) => {
        const n = parseInt(row.dataset.covers, 10) || 0;
        row.addEventListener('pointerenter', () => this.focusOn(n));
        row.addEventListener('pointerleave', () => this.clear());
      });
    }
    focusOn(n) {
      this.classList.add('is-focus');
      this.tiles.forEach((tile, i) => tile.classList.toggle('is-out', i >= n));
    }
    clear() {
      this.classList.remove('is-focus');
      this.tiles.forEach((tile) => tile.classList.remove('is-out'));
    }
  }
  if (!customElements.get('vantra-timeline')) customElements.define('vantra-timeline', VantraTimeline);

  } catch(e) { console.error(e); }
})();
})();
